import React from 'react';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import SettingStyles from '../SettingStyle.module.scss';
import { StaffList } from './StaffList';

export const Page: React.FC = () => (
  <DefaultV2>
    <ClientSettingLayout>
      <h2 className={SettingStyles.SettingTitle}>担当者一覧</h2>
      <StaffList />
    </ClientSettingLayout>
  </DefaultV2>
);
